var util = angular.module('gymsystem.util');
util.factory('pubsub', ['$rootScope', function ($rootScope) {
        var list = {};
        var published = {};
        var unsubscribeCurrent;
        function publish(name, data) {
            published[name] = data;
            if (!list[name])
                return;
            var result = [];
            for (var _i = 0, _a = list[name].slice(); _i < _a.length; _i++) {
                var fn = _a[_i];
                try {
                    if (fn === false)
                        result.push(false);
                    else {
                        unsubscribeCurrent = false;
                        result.push(fn(data));
                        if (unsubscribeCurrent)
                            unsubscribe(name, fn);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
            return result;
        }
        function subscribe(name, callback, fire) {
            // fire - to call a callback immediately if this event have already published
            var scope = this;
            if (scope.$on && scope !== $rootScope) {
                scope.$on('$destroy', function () {
                    unsubscribe(name, callback);
                });
            }
            if (!list[name])
                list[name] = [];
            if (fire && published.hasOwnProperty(name)) {
                unsubscribeCurrent = false;
                callback(published[name]);
                if (unsubscribeCurrent)
                    return;
            }
            list[name].push(callback);
        }
        function unsubscribe(name, callback) {
            if (!name && !callback) {
                unsubscribeCurrent = true;
                return;
            }
            if (!list[name])
                return;
            var i = list[name].indexOf(callback);
            if (i >= 0)
                list[name].splice(i, 1);
        }
        subscribe.publish = publish;
        subscribe.unsubscribe = unsubscribe;
        return {
            inject: function (root) {
                var ScopeConstructor = Object.getPrototypeOf(root);
                ScopeConstructor.pubsub = subscribe;
            },
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            publish: publish
        };
    }]);
